import React from 'react';
import styled from 'styled-components';
import { LockToolbar } from '../../../../editJournal/toolset/assets/icons';

const LockWrapper = styled.span`
  /* padding: 4px 12px; */
`;

/**
 * TODO: Conditionally render locked or unlocked toolbar
 */
const Lock = () => (
  <LockWrapper>
    <LockToolbar />
  </LockWrapper>
);

export default Lock;
